export default __webpack_public_path__ + "static/media/wc.776e685d.svg";